
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { OrderModel } from 'models/generated/Entities.GormCrm.Order';
import { ValidationResultModel } from 'models/generated/Models.ValidationResult';
import { ProductPlanModel } from 'models/generated/Entities.GormCrm.ProductPlan';
import { OrderLineModel } from 'models/generated/Entities.GormCrm.OrderLine';
import { SalesCommissionViewModel } from 'models/generated/Entities.GormCrm.SalesCommissionView';


const _gormCrm_OrderControllerHelper = new Map<string, Object>();
_gormCrm_OrderControllerHelper.set('GetOrderById', OrderModel);
_gormCrm_OrderControllerHelper.set('GetOrders', OrderModel);
_gormCrm_OrderControllerHelper.set('ValidateOrder', ValidationResultModel);
_gormCrm_OrderControllerHelper.set('CreateNewOrder', OrderModel);
_gormCrm_OrderControllerHelper.set('CreateProductPlanFromOrderLines', ProductPlanModel);
_gormCrm_OrderControllerHelper.set('GetOrderLinesByIds', OrderLineModel);
_gormCrm_OrderControllerHelper.set('GetOrdersByIds', OrderModel);
_gormCrm_OrderControllerHelper.set('GetSalesCommissionView', SalesCommissionViewModel);
_gormCrm_OrderControllerHelper.set('GetUndeliveredOrders', OrderModel);


export const gormCrm_OrderControllerHelper = _gormCrm_OrderControllerHelper;

